import { Table } from 'flowbite-react';
import React, { useContext, useEffect } from 'react';
import axios from 'axios';
import { GlobalContext } from '../context/GlobalContext';

const ListJobVacancy = () => {

    let number = 1;

    const { state, handleFunction } = useContext(GlobalContext);

    let {
        data,
        setData,
        fetchStatus,
        setfetchStatus
    } = state

    let {
        setStatus,
        singkatString,
        handleDelete,
        handleEdit
    } = handleFunction

    useEffect(() => {
        if (fetchStatus === true) {
            axios.get("https://dev-example.sanbercloud.com/api/job-vacancy").then((res) => {
                setData([...res.data.data])
            }).catch((error) => {
                console.log(error);
            })
            setfetchStatus(false)
        }
    }, [fetchStatus, setfetchStatus])

    return (
        <div className="w-full border-b border-solid border-stone-200">
            <h1 className="px-4 py-4 text-5xl sm:text-xl md:text-2xl lg:text-3xl font-bold">
                Manage Data
            </h1>
            <div className='w-11/12 my-0 mb-6 mx-auto'>
                <Table>
                    <Table.Head>
                        <Table.HeadCell>
                            No
                        </Table.HeadCell>
                        <Table.HeadCell>
                            Title
                        </Table.HeadCell>
                        <Table.HeadCell>
                            Description
                        </Table.HeadCell>
                        <Table.HeadCell>
                            Status
                        </Table.HeadCell>
                        <Table.HeadCell>
                            Company Name
                        </Table.HeadCell>
                        <Table.HeadCell>
                            City
                        </Table.HeadCell>
                        <Table.HeadCell>
                            Action
                        </Table.HeadCell>
                    </Table.Head>
                    <Table.Body className="divide-y">
                        {data !== null && data.map((res) => {
                            return (
                                <Table.Row key={res.id} className="bg-white dark:border-gray-700 dark:bg-gray-800">
                                    <Table.Cell className="whitespace-nowrap font-medium text-gray-900 dark:text-white">
                                        {number++}
                                    </Table.Cell>
                                    <Table.Cell>
                                        {singkatString(res.title)}
                                    </Table.Cell>
                                    <Table.Cell>
                                        {singkatString(res.job_description)}
                                    </Table.Cell>
                                    <Table.Cell>
                                        {setStatus(res.job_status)}
                                    </Table.Cell>
                                    <Table.Cell>
                                        {res.company_name}
                                    </Table.Cell>
                                    <Table.Cell>
                                        {res.company_city}
                                    </Table.Cell>
                                    <Table.Cell>
                                        <div className='mr-2'>
                                            <button onClick={handleEdit} value={res.id} className="focus:outline-none text-white bg-yellow-200 hover:bg-yellow-400 focus:ring-4 focus:ring-yellow-300 font-normal rounded-lg text-sm px-2 py-2.5 mr-2 mb-2 dark:focus:ring-yellow-900">Edit</button>
                                        </div>
                                        <button onClick={handleDelete} value={res.id} className="focus:outline-none text-white bg-red-500 hover:bg-red-800 focus:ring-4 focus:ring-red-300 font-normal rounded-lg text-sm px-2 py-2.5 mr-2 mb-2 dark:bg-red-600 dark:hover:bg-red-700 dark:focus:ring-red-900">Delete</button>
                                    </Table.Cell>
                                </Table.Row>
                            )
                        })}
                    </Table.Body>
                </Table>
            </div>
        </div>
    )
}

export default ListJobVacancy;
